import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import notfound from "assets/images/notfound.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const Region = (props) => {
    const cellRenderers = {
        id: () => <td>{props.region?.id}</td>,
        name: () => (
            <td className="name">
                <span>
                    <div>
                        <img
                            src={
                                props.region.image && props.region.image !== "null"
                                    ? props.region.image
                                    : notfound
                            }
                            alt="region"
                        />
                    </div>
                    <div>
                        <h6>{props.region?.name}</h6>
                    </div>
                </span>
            </td>
        ),
        city: () => <td>{props.region?.city ? props.region.city.name : "لا يوجد"}</td>,
        location: () => (
            <td>
                {props.region?.location ? (
                    <a href={props.region?.location} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faMapLocationDot} size="xl" color="red" />
                    </a>
                ) : (
                    "لا يوجد"
                )}
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    region={props.region}
                    edit={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleDelete();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default Region;
